import Grid from '@mui/material/Grid';
import type { MaxAdDurationStatePayload } from '@openx/types/targeting/video.ts';
import type { JSX } from 'react';
import { TypeDropdown } from './components/TypeDropdown.tsx';
import { useMaxAdDuration } from './hooks/useMaxAdDuration.tsx';

type Props = {
  onChange: (typeParams: MaxAdDurationStatePayload | null) => void;
  value: MaxAdDurationStatePayload | null;
};

export const MaxAdDuration = ({ onChange, value }: Props): JSX.Element => {
  const { type, durationSelection, handleTypeChange } = useMaxAdDuration(value, onChange);

  return (
    <Grid
      container
      spacing={1}
      columns={27}
      sx={{
        alignItems: 'flex-end',
      }}
    >
      <Grid size={8}>
        <TypeDropdown targetingType={type} setTargetingType={handleTypeChange} />
      </Grid>

      {durationSelection}
    </Grid>
  );
};
